import { render } from "./TeamBotManager.vue?vue&type=template&id=cd374958"
import script from "./TeamBotManager.vue?vue&type=script&lang=js"
export * from "./TeamBotManager.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__